import React, { useContext } from "react";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import { Link, useLocation } from "react-router-dom";
import "../Styles.css";
// const psl = require("psl");

const DocWebSideNavLinks = (props) => {
    const location = useLocation();
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);

    // Get doctor name and specialty
    const doctorName = payload?.clinicName || "HealthCare";
    const specialty = payload?.speciality || l?.family_doctor || "Family Doctor";

    return (
        <>
            {/* User Info Header */}
            {/* <div className="wsnUserHeader">
                <div className="wsnUserAvatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M4.8 2.3A2 2 0 0 1 6.5 1.5h11a2 2 0 0 1 1.7.8l2.5 4a2 2 0 0 1-.1 2.4l-9 10.5a1 1 0 0 1-1.5 0l-9-10.5a2 2 0 0 1-.1-2.4l2.8-4z" />
                        <path d="M12 22v-8.3" />
                        <circle cx="12" cy="8" r="2" />
                        <path d="M12 6V4" />
                        <path d="M10 8H8" />
                        <path d="M16 8h-2" />
                    </svg>
                </div>
                <div className="wsnUserInfo">
                    <span className="wsnUserName">{doctorName}</span>
                    <span className="wsnUserRole">{specialty}</span>
                </div>
            </div> */}

            <ul className="wsnGroup">
                <li className="wsnItem">
                    <Link
                        to="/doctor-appointments"
                        className={location.pathname === "/doctor-appointments" ? "wsnLink wsnAcitve" : "wsnLink"}
                    >
                        <img src="/images/icons/appointments-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.apptmnts}</span>
                        </div>
                        {/* <div className="linkCounter">
                        <span>15</span>
                    </div> */}
                    </Link>
                </li>
                <li className="wsnItem">
                    <Link to="/doctor-schedules" className={location.pathname === "/doctor-schedules" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/create-schedule-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.create_sched}</span>
                        </div>
                    </Link>
                </li>
                <li className="wsnItem">
                    <Link
                        to="/doctor-coupon"
                        onClick={props.hideMenu}
                        className={location.pathname === "/doctor-coupon" ? "wsnLink wsnAcitve" : "wsnLink"}
                    >
                        <img src="/images/icons/patients-list.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>Coupons</span>
                        </div>
                    </Link>
                </li>
                {/* <li className="wsnItem">
                    <Link to="/doctor-uploads" className={location.pathname === "/doctor-uploads" ? "wsnLink wsnAcitve" : "wsnLink"} >
                        <img src="/images/icons/uploads-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.waiting_uploads}</span>
                        </div>
                    </Link>
                </li> */}
                <li className="wsnItem">
                    <Link to="/doctor-invites" className={location.pathname === "/doctor-invites" ? "wsnLink wsnAcitve" : "wsnLink"}>
                        <img src="/images/icons/invite-outline.png" className="linkIcon invertWhite" alt="icon" />
                        <div className="linkTxtBlock">
                            <span>{l.invite}</span>
                        </div>
                    </Link>
                </li>
            </ul>
        </>
    );
};

export default DocWebSideNavLinks;
